enum Routes {
  ROOT = '/',
  WELCOME = '/welcome',
  DASHBOARD = '/dashboard',
  REPORTS = '/reports',
  LEADERBOARD = '/leaderboard',
  LOGIN = '/login',
  LOGIN_WITH_PARAMETERS = '/login/:id?',
  REGISTER = '/register',
  REGISTER_FROM_INVITATION_WITH_PARAMETERS = '/register-from-invitation/:id?',
  RESET_PASSWORD = '/reset-password',
  RESET_PASSWORD_WITH_PARAMETERS = '/reset-password/:id?',
  CUSTOMERS = '/customers',
  INVITATIONS = '/invitations',
  INVITE_CUSTOMER = '/invite-customer',
  DEVELOPERS = '/developers',
  SETTINGS = '/settings',
  PROFILE_SETTINGS = '/profile-settings',
  BILLINGS = '/billings',

  // UPGRADE
  UPGRADE = '/upgrade',
  UPGRADE_WITH_PARAMETERS = '/upgrade/:cycle?/:plan?',

  // REPORT
  REPORT = '/report',
  REPORT_MODAL_EXPORT = '/report/export',
  REPORT_MODAL_EXPORT_SUCCESS = '/report/export-success',
  REPORT_MODAL_EXPORT_FAIL = '/report/export-fail',
  REPORT_MODAL_CHANGE_CATEGORY = '/report/change-category',
  REPORT_MODAL_CHANGE_CATEGORY_FAIL = '/report/change-category-fail',
  REPORT_MODAL_CHANGE_CATEGORY_SUCCESS = '/report/change-category-success',
  REPORT_MODAL_DELETE = '/report/delete',
  REPORT_MODAL_DELETE_SUCCESS = '/report/delete-success',
  REPORT_MODAL_DELETE_FAIL = '/report/delete-fail',
  REPORT_MODAL_RECURRING_TRANSACTIONS = '/report/recurring-transactions',
}

export default Routes;
